import { render, staticRenderFns } from "./FavoritesEmptyState.vue?vue&type=template&id=40cd60eb&scoped=true"
import script from "./FavoritesEmptyState.vue?vue&type=script&lang=js"
export * from "./FavoritesEmptyState.vue?vue&type=script&lang=js"
import style0 from "./FavoritesEmptyState.vue?vue&type=style&index=0&id=40cd60eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cd60eb",
  null
  
)

export default component.exports